import React, { forwardRef } from 'react';
import styles from './FirstStepContainer.module.scss';

const FirstStepContainer = forwardRef(({ children }, ref) => {
  return (
    <div className={styles.container} ref={ref}>
      {children}
    </div>
  );
});

export default FirstStepContainer;